"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowSpacer = exports.SelectorContainer = exports.UnselectedButton = exports.SelectedButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const core_1 = require("@material-ui/core");
const theme_style_1 = __importDefault(require("../../../theme.style"));
function SelectedButton(props) {
    const ButtonTemp = styled_1.default(core_1.Button) `
    &.MuiButton-contained {
      background-color: ${theme_style_1.default.colors.lightGreen};
      border: 1px solid transparent;
      width: 100%;
      height: 48px;
      text-transform: none;
      border-radius: 4px;
    }
  `;
    return react_1.default.createElement(ButtonTemp, Object.assign({ variant: "contained", disableElevation: true }, props));
}
exports.SelectedButton = SelectedButton;
function UnselectedButton(props) {
    const ButtonTemp = styled_1.default(core_1.Button) `
    &.MuiButton-contained {
      background-color: ${theme_style_1.default.colors.white};
      border: 1px solid ${theme_style_1.default.colors.grey5};
      width: 100%;
      height: 48px;
      text-transform: none;
      border-radius: 4px;
    }
  `;
    return react_1.default.createElement(ButtonTemp, Object.assign({ variant: "contained", disableElevation: true }, props));
}
exports.UnselectedButton = UnselectedButton;
const SelectorContainer = styled_1.default.div `
  display: flex;
  flex-direction: row;
`;
exports.SelectorContainer = SelectorContainer;
const RowSpacer = styled_1.default.div `
  display: flex;
  ${(props) => `width: ${props.width}px;`}
  flexgrow: 0;
  flex-shrink: 0;
`;
exports.RowSpacer = RowSpacer;
